import React from 'react';
import styles from './Select.module.css';
import { classNames } from '../../utils/helpers';
import { ChevronDownIcon } from '../Icons';

function Select({
  label,
  error,
  hint,
  options,
  placeholder = 'Select an option',
  fullWidth = true,
  disabled = false,
  className,
  containerClassName,
  ...props
}) {
  return (
    <div className={classNames(styles.container, fullWidth && styles.fullWidth, containerClassName)}>
      {label && <label className={styles.label}>{label}</label>}
      <div className={styles.selectWrapper}>
        <select
          className={classNames(
            styles.select,
            error && styles.error,
            disabled && styles.disabled,
            className
          )}
          disabled={disabled}
          {...props}
        >
          {placeholder && (
            <option value="" disabled>
              {placeholder}
            </option>
          )}
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <ChevronDownIcon className={styles.icon} />
      </div>
      {(error || hint) && (
        <span className={classNames(styles.hint, error && styles.errorText)}>
          {error || hint}
        </span>
      )}
    </div>
  );
}

export default Select;
